import React, { useContext } from "react";
import { ProductContext } from "../../context/ProductContext";

const ApparelFields: React.FC = () => {
  const context = useContext(ProductContext);

  if (!context?.product) return null;

  const {
    apparelCategory,
    fabricType,
    sizeOptions,
    colorOptions,
    pattern,
    careInstructions,
    headingColor,
    textColor,
    headingFontStyle,
    fontStyle
  } = context.product;

  return (
    <>
      {apparelCategory && (
        <div className="w-full max-w-2xl mx-auto px-4 mb-5 font-mulish text-left">
          <h2
            style={{ letterSpacing: "0.01em", color: headingColor || "#000000", fontFamily: headingFontStyle }}
            className="text-base font-bold leading-tight pb-2"
          >
            Apparel Category
          </h2>
          <p style={{ color: textColor, fontFamily: fontStyle }} className="text-sm mt-1 leading-snug">
            {apparelCategory}
          </p>
        </div>
      )}
      {fabricType && (
        <div className="w-full max-w-2xl mx-auto px-4 mb-5 font-mulish text-left">
          <h2
            style={{ letterSpacing: "0.01em", color: headingColor || "#000000", fontFamily: headingFontStyle }}
            className="text-base font-bold leading-tight pb-2"
          >
            Fabric Type
          </h2>
          <p style={{ color: textColor, fontFamily: fontStyle }} className="text-sm mt-1 leading-snug">
            {fabricType}
          </p>
        </div>
      )}
      {sizeOptions && (
        <div className="w-full max-w-2xl mx-auto px-4 mb-5 font-mulish text-left">
          <h2
            style={{ letterSpacing: "0.01em", color: headingColor || "#000000", fontFamily: headingFontStyle }}
            className="text-base font-bold leading-tight pb-2"
          >
            Size Options
          </h2>
          <p style={{ color: textColor, fontFamily: fontStyle }} className="text-sm mt-1 leading-snug">
            {Object.keys(sizeOptions).filter(size => sizeOptions[size]).join(", ")}
          </p>
        </div>
      )}
      {colorOptions && (
        <div className="w-full max-w-2xl mx-auto px-4 mb-5 font-mulish text-left">
          <h2
            style={{ letterSpacing: "0.01em", color: headingColor || "#000000", fontFamily: headingFontStyle }}
            className="text-base font-bold leading-tight pb-2"
          >
            Color Options
          </h2>
          <p style={{ color: textColor, fontFamily: fontStyle }} className="text-sm mt-1 leading-snug">
            {colorOptions}
          </p>
        </div>
      )}
      {pattern && (
        <div className="w-full max-w-2xl mx-auto px-4 mb-5 font-mulish text-left">
          <h2
            style={{ letterSpacing: "0.01em", color: headingColor || "#000000", fontFamily: headingFontStyle }}
            className="text-base font-bold leading-tight pb-2"
          >
            Pattern
          </h2>
          <p style={{ color: textColor, fontFamily: fontStyle }} className="text-sm mt-1 leading-snug">
            {pattern}
          </p>
        </div>
      )}
      {careInstructions && (
        <div className="w-full max-w-2xl mx-auto px-4 mb-5 font-mulish text-left">
          <h2
            style={{ letterSpacing: "0.01em", color: headingColor || "#000000", fontFamily: headingFontStyle }}
            className="text-base font-bold leading-tight pb-2"
          >
            Care Instructions
          </h2>
          <p style={{ color: textColor, fontFamily: fontStyle }} className="text-sm mt-1 leading-snug">
            {careInstructions}
          </p>
        </div>
      )}
    </>
  );
};

export default ApparelFields;
